require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-zb-25-vr.json") })
        }
      }, "path---photos-professional-zb-25-vr");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-zb-25-vr!./.cache/json/photos-professional-zb-25-vr.json
// module id = 1182
// module chunks = 231608221292675